/**
 * DocumentsTab — the customer's signed packets from account opening (Bill 2026-10-17: "point them at each
 * customer's signed packet from opening, which ROP does have"). It used to link out to the document library,
 * which never held these files under the customer, so it always showed nothing.
 */
import { SignedPackets } from '@/components/documents/SignedPackets';
import { useSignedPackets } from '@/components/documents/useSignedPackets';

export interface DocumentsTabProps {
  cifId: string;
}

export function DocumentsTab({ cifId }: DocumentsTabProps): JSX.Element {
  const { packets, loading, error } = useSignedPackets(cifId);
  return (
    <SignedPackets packets={packets} loading={loading} error={error}
      emptyText="No signed packets yet. Documents appear here after this customer signs at an account opening." />
  );
}
